const day_sort = {
  mon: 1,
  tue: 2,
  wed: 3,
  thu: 4,
  fri: 5,
  sat: 6,
  sun: 7
};

export function sort_by_day(a, b) {
  return day_sort[a.day] - day_sort[b.day];
}

export function sort_by_time(a, b) {
  if (a.start > b.start) {
    return 1;
  }

  if (b.start > a.start) {
    return -1;
  }

  return 0;
}
